module.exports = __webpack_public_path__ + "static/JD-35d2fd343215acf2b3d1007b4821a4dd.png";